export default __webpack_public_path__ + "static/media/slide12.01c14bfe.png";